// extracted by mini-css-extract-plugin
export default {"wrapper":"Profile_wrapper__hTwrt","header":"Profile_header__aKzBF","edit":"Profile_edit__5DiWF"};